/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskAlexaRanking
 */
export interface ExecRiskAlexaRanking {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskAlexaRanking
     */
    alexa_rank?: number;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskAlexaRanking
     */
    updated?: string;
}

/**
 * Check if a given object implements the ExecRiskAlexaRanking interface.
 */
export function instanceOfExecRiskAlexaRanking(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskAlexaRankingFromJSON(json: any): ExecRiskAlexaRanking {
    return ExecRiskAlexaRankingFromJSONTyped(json, false);
}

export function ExecRiskAlexaRankingFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskAlexaRanking {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'alexa_rank': !exists(json, 'alexa_rank') ? undefined : json['alexa_rank'],
        'updated': !exists(json, 'updated') ? undefined : json['updated'],
    };
}

export function ExecRiskAlexaRankingToJSON(value?: ExecRiskAlexaRanking | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'alexa_rank': value.alexa_rank,
        'updated': value.updated,
    };
}

